module.exports = __webpack_public_path__ + "img/player.4ff219a4.svg";